import InstagramDirectAuthorisationButton from '../../components/authorise/platforms/InstagramDirectAuthorisationButton'
import { AccountOnboardingLayout } from '../../containers/AccountOnboardingLayout'

/**
 * This page is used to add an Instagram account to Arwen using authorisation against the Instagram API not the Facebook API. T
 */
function NewInstagramAccountPage() {
    return (
        <AccountOnboardingLayout title="Add Instagram profile">
            <p>Log in to your Instagram on this browser to make sure it's the right profile.</p>

            <InstagramDirectAuthorisationButton />
        </AccountOnboardingLayout>
    )
}

export default NewInstagramAccountPage
